import { useCurrentFair } from "../lib/fairSchedule";

/* Small badge: "Opens in N days" / "Open now" for the current fair. Renders nothing after
   the last fair closes. Client-only text (see useCurrentFair). */
export const Countdown = ({ className = "", testId = "fair-countdown" }) => {
  const { label } = useCurrentFair();
  if (!label) return null;
  return (
    <span
      className={`ml-2 inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] uppercase tracking-widest font-bold text-greige bg-accent align-middle ${className}`}
      data-testid={testId}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-greige animate-pulse" aria-hidden="true" />
      {label}
    </span>
  );
};
